import './home-page.scss'
import { useLoadPageComponents, useLogger } from '@omnia/ui/src/lib'
import type { FC } from 'react'
import HeroCarousel from '@/common/components/heroCarousel/HeroCarousel'
import { Meta } from '@/common/components/meta/Meta'
import { Grid } from '@/features/grid/Grid'
import { PageTitle } from '@/features/layout/pageTitle/PageTitle'
import { HomePageResponse } from './props'

export const HomePage: FC = () => {
    const logger = useLogger('HomePage')
    const { pageResponse, isPending } = useLoadPageComponents(new HomePageResponse())

    logger.trace('Rendering', { pageResponse, isPending })

    if (isPending) {
        return null
    }

    return (
        <div className="home-page">
            <Meta {...pageResponse} />
            <PageTitle text={pageResponse.pageTitle} hide={pageResponse.hideTitle} />
            <HeroCarousel items={pageResponse.components.HeroCarousel} />
            <Grid rows={pageResponse.grid} />
        </div>
    )
}
